<template>
  <div class="wrap">
    <Navbar :title="$t('newAdd.Withdraw')">
      <template #right>
        <div class="right_btn" @click="handleLinkPage('withdraw-list')">
          {{ $t("newAdd.Record") }}
        </div>
      </template>
    </Navbar>
    <div class="content">
      <div class="bank" @click="handleLinkPage(`walletList?id=${bank_id}`)">
        <div class="bank_cont">
          <div class="bank_img">
            Ewallet/Bank
            <!-- <template v-if="bankInfo.bank == 'DANA'">
              <img src="@/assets/new/bank/dana.png" alt="">
            </template>
            <template v-else>
              <img src="@/assets/new/bank/ovo.png" alt="">
            </template> -->
          </div>
          <div class="cont_right">
            <!-- <template v-if="bankInfo.bank == 'GCASH'"> -->
              <div class="right_item">
                <div class="right_item">
              <span>{{ $t('钱包名字') }}:</span>{{ bankInfo.bank }}
            </div>
                <span>{{ $t('账户姓名') }}:</span>{{ bankInfo.name }}
              </div>
              <div class="right_item">
                <span>{{ $t('账号') }}:</span>{{ bankInfo.card }}
              </div>
            <!-- </template>
            <template v-else>
              <div class="right_item">
                <span>{{ $t('用户名') }}:</span>{{ bankInfo.name }}
              </div>
              <div class="right_item">
                <span>{{ $t('银行名称') }}:</span>{{ bankInfo.open }}
              </div>
              <div class="right_item">
                <span>{{ $t('银行代码') }}:</span>{{ bankInfo.card }}
              </div>
            </template> -->
          </div>
        </div>
        <van-icon name="arrow" color="#eee" size="18" />
      </div>
      <div class="line"></div>
      <van-cell>
        <div slot="title" class="balance">
          <span class="balance-title">{{ $t("newAdd.AllBalance") }}
          </span>
          <span class="balance-right red">{{ userInfo.money }}
          </span>
        </div>
      </van-cell>
      <div class="line"></div>
      <div class="withdraw_amount">
        <div class="title">{{ $t("withdraw.label.enterAmount") }}:</div>
        <van-field v-model="money" center v-if="country != 'tr'" clearable label-width="200" label="" type="digit"
          :placeholder="$t('newAdd.EnterWithdrawalAmount')" :v-else="$t('newAdd.EnterWithdrawalAmount')">
        </van-field>
      </div>
      <div class="withdraw_amount">
        <div class="title">{{ $t('交易密码') }}</div>
        <van-field v-model="paypass" :placeholder="$t('请输入交易密码')" />
      </div>
      <button class="button" @click="Withdrawal">
        {{ $t("newAdd.AskNow") }}
      </button>
      <van-dialog v-model="isshowDialog" title="Password" show-cancel-button cancel-button-text="CANCEL"
        confirm-button-text="CONFIRM" confirmButtonColor="var(--theme)" @confirm="onSubmit" @cancel="editValue = ''">
        <van-field v-model="editValue" autofocus="true" type="password"
          :placeholder="$t('newAdd.EnterPwdPlaceholder')" />
      </van-dialog>
      <van-dialog v-model="showAddBankWarn" :title="$t('newAdd.warmTitle')" show-cancel-button
        :cancel-button-text="$t('btn.cancel')" :confirm-button-text="$t('btn.confirm')"
        confirmButtonColor="var(--theme)" @confirm="toAddBank" @cancel="$router.back()" class="warmDialog">
        <div class="dialog_content">
          {{
            verConfig.needBank
              ? this.$t("newAdd.NotHaveCard")
              : this.$t("newAdd.NotHaveWallet")
          }}
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import { GET_USER_BANK_INFO, WITHDRAW, getUserInfoNew, BANK_LIST } from "@/api";
import { isObject, count, getUserInfo, getToken } from "@/utils";
import { NavBar, cell, icon, field, Dialog, Toast, Tab, Tabs } from "vant";
import Cookies from "js-cookie";
import Tabbar from "@/components/Tabbar";
import verConfig from "../../utils/verConfig";
import Navbar from "@/components/JNav";
import { maskMiddle } from "@/utils/common"
export default {
  name: "",
  components: {
    [NavBar.name]: NavBar,
    [cell.name]: cell,
    [icon.name]: icon,
    [field.name]: field,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    Tabbar,
    Navbar,
  },
  data() {
    return {
      sms: "",
      country: Cookies.get("language"),
      money: "",
      bankInfo: {},
      userInfo: {},
      isshowDialog: false,
      editValue: "",
      money_not: 0,
      paypass: '',
      withdrawType: verConfig.needBank ? "bank" : "coin",
      rateData: {},
      showAddBankWarn: false,
      bankList: []
    };
  },
  created() {
    // getUserInfoNew();
    this.$nextTick(() => {
      this.getUserBankInfo();
    })
  },
  mounted() {
    // this.userInfo = getUserInfo();
    this.getUserInfo();
  },
  methods: {
    async getBank() {
      try {
        const res = await BANK_LIST();
        const result = Object.entries(res.data).map(([type, value]) => ({ type, value }))
        this.bankList = result;
      } catch (error) {
      }
    },
    getType(item) {
      const itmes = this.bankList.find(i => i.type == item);
      return itmes?.value || item
    },
    handleLinkPage(path) {
      if (getToken()) {
        this.$router.push(`/${path}`);
      } else {
        this.$toast($t("newAdd.NotLogin"));
        setTimeout(() => {
          this.$router.replace({ name: "login" });
        }, 1000);
      }
    },
    bankInfoInit(data) {
      this.bank = data.bank;
      this.bank_id = data.id;
      this.bank_name = data.name;
      this.bank_cardl4 = data.card_l4;
      this.bankInfo = { ...data, card: maskMiddle(data.card) };
      this.withdrawType = "bank";
    },
    toAddBank() {
      this.itemClick("BankCardAdd");
    },
    getUserInfo() {
      Toast.loading();
      this.$api.getUserInfo((res) => {
        Toast.clear();
        this.userInfo = res;
      }, (err) => { Toast.clear(); });
    },
    getUserBankInfo() {
      const bankInfo = JSON.parse(this.$cookie.get("selectBankInfo"));
      Toast.loading();
      GET_USER_BANK_INFO().then((r) => {
        Toast.clear();
        if (r.data.ret === 1) {
          Toast.clear();
          if (isObject(r.data.data) && count(r.data.data) > 0) {
            if (this.userInfo.setpaypass < 1) {
              Dialog.alert({
                message: this.$t('未设置交易密码'),
                showCancelButton: true,
                confirmButtonText: this.$t('My.Button.Two'),
                cancelButtonText: this.$t('My.Button.One')
              }).then(() => {
                this.$router.push('/PaymentCode')
              }).catch(() => {
                this.$router.back();
              });
              return
            }
            const banklist = r.data.data
            if (bankInfo) {
              if (banklist.some(item => item.id === bankInfo.id)) {
                this.bankInfoInit(bankInfo)
                return
              }
              let bankLists = { ...banklist[0], bank: this.getType(banklist[0].bank) }
              this.bankInfoInit(bankLists);
              this.$cookie.set("selectBankInfo", JSON.stringify(bankLists))
            } else {
              let findItem = banklist.find(item => item.default > 0)
              let bankLists = { ...findItem, bank: this.getType(findItem.bank) }
              this.bankInfoInit(bankLists);
              this.$cookie.set("selectBankInfo", JSON.stringify(bankLists))
            }
          } else {
            Toast.clear();
            this.showAddBankWarn = true;
          }
        } else {
          Toast.clear();
          Toast(this.$t("newAdd.GetBankInfoFail"));
        }
      }).catch((e) => {
        Toast.clear();
      });
    },
    itemClick(page) {
      this.$router.push({ name: page });
    },
    allHandler() {
      this.money = this.userInfo.money;
    },
    Withdrawal() {
      this.confirm();
    },
    confirm() {
      Toast.loading();
      WITHDRAW({
        money: this.money,
        paypass: this.paypass,
        bankid: this.bank_id,
      }).then((r) => {
        Toast.clear();
        if (r.data.ret === 1) {
          Toast.clear();
          Toast(r.data.msg);
          let timer = setTimeout(()=>{
            getUserInfoNew();
            this.$router.back();
            clearTimeout(timer)
          },1000)
        } else {
          Toast.clear();
          Toast(r.data.msg);
        }
      }).catch((e) => {
        Toast.clear();
      });
    },
    async onSubmit() {
      this.isshowDialog = false;
      if (this.editValue.trim().length !== 4) {
        Toast(this.$t("newAdd.EnterValidPayPwd"));
      } else {
        const { data } = await extract({
          money: this.money,
          paypass: this.editValue,
          bankid: this.bankInfo.id,
        });
        Toast(data.msg);
        this.editValue = "";
        this.$router.push("/login");
      }
    },
  },
  computed: {
    money_can() {
      return this.userInfo.money_not > 0 ? 0 : this.userInfo.money;
    },
    actualAmount() {
      let amount = 0;
      if (Number(this.money)) {
        if (String(this.rateData.value).indexOf("%") === -1) {
          amount = (this.money - this.rateData.value) / this.rateData.rate;
        } else {
          const fixedNum = 100000000;
          amount =
            Math.round(
              ((this.money *
                (1 -
                  String(this.rateData.value).substring(
                    0,
                    String(this.rateData.value).indexOf("%")
                  ) /
                  100)) /
                this.rateData.rate) *
              fixedNum
            ) / fixedNum;
        }
      }
      return amount > 0 ? amount : 0;
    },
  },
};
</script>

<style lang="less" scoped>
@wrapPadding: calc(12rem / 16);
@comRadius: 10px;
@comBG: var(--bg1);

.wrap {
  min-height: 100vh;
  background: var(--light);

  .right_btn {
    background-color: var(--bg);
    border: none;
    color: var(--light);
    font-size: calc(14rem / 16);
    padding: 8px 12px;
    border-radius: 4px;
  }

  .content {
    .warmDialog {
      background: var(--bg);

      .dialog_content {
        font-size: calc(15rem / 16);
        padding: calc(18rem / 16);
        color: var(--gold);
      }

      /deep/ .van-dialog__cancel,
      /deep/ .van-dialog__confirm {
        background: var(--bg) !important;
      }

      /deep/ .van-dialog__cancel {
        color: #4acfff;
      }

      /deep/ .van-dialog__header {
        color: var(--gold);
      }
    }

    .item-title {
      color: #333;
      font-size: calc(14rem / 16);
    }

    .balance-title {
      color: var(--btnsizeColor);
    }

    .van-icon {
      color: #333;
    }

    .bank {
      padding: calc(10rem /16);
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: calc(10rem / 16);

      .bank_cont {
        display: flex;
        align-items: center;
        gap: calc(5rem / 16);

        .bank_img {
          img {
            height: calc(44rem / 16);
            display: block;
          }
        }

        .cont_right {
          flex: 1;

          .right_item {
            margin-top: calc(5rem / 16);
            font-size: calc(14rem / 16);
            color: #333;

            span {
              margin-right: calc(5rem / 16);
            }
          }
        }
      }
    }


    .line {
      height: calc(8rem / 16);
      background-color: #f2f2f2;
    }

    /deep/ .van-cell {
      border-radius: @comRadius;
      font-size: calc(12rem / 16);
      color: #333;
      display: flex;
      align-items: center;
      line-height: 24px !important;

      &::after {
        border: none;
      }

      .title {
        display: flex;
        align-items: center;

        .item-right {
          width: calc(250rem / 16);
          display: flex;
          flex-direction: row;
          margin-left: calc(15rem / 16);

          .item-value-bank {
            color: #333;
          }
        }
      }

      .balance {
        width: calc(185rem / 16);
        padding: 6px 0;

        .balance-title {
          width: calc(200rem / 16);
          color: #333;
          font-size: calc(14rem / 16);
        }

        .balance-right {
          margin-left: calc(10rem / 16);
          font-size: calc(14rem / 16);
        }
      }

      .default {
        color: #000;

        .item-value {
          margin-left: calc(10rem / 16);
        }
      }

      .red {
        color: var(--yellow);
        // color: #ff0000;
      }
    }

    .item-need {
      color: #dc1323;
      text-align: right;
      font-size: calc(12rem / 16);
      margin-top: calc(12rem / 16);
      margin-right: calc(12rem / 16);
      margin-bottom: calc(12rem / 16);
    }

    .withdraw_amount {
      margin: @wrapPadding;

      .title {
        font-size: calc(14rem / 16);
        text-indent: 0.6em;
        padding-bottom: calc(6rem / 16);
      }

      .van-cell {
        margin: calc(6rem / 16) 0 0;
        width: 100%;
        border: 1px solid #e4e4e4;
      }

      /deep/ .van-field {
        font-size: calc(15rem / 16);

        .van-field__label {
          width: calc(15rem / 16);
        }

        .van-field__body {
          input {
            // text-align: center;
            color: #333;
          }
        }

        button {
          color: var(--theme);
          background-color: #fff;
        }
      }
    }

    .button {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: calc(340rem / 16);
      height: calc(43rem / 16);
      font-size: calc(15rem / 16);
      margin-top: calc(31rem / 16);
      background: #cf312b;
      border-radius: calc(5rem / 16);
      border: none;
      color: var(--light);
    }
  }
}
</style>